import React from 'react'
// import Lottie from 'lottie-react'
import dynamic from 'next/dynamic'

import Icon from '@/Icon'

import loadAnimation from './loading.json'

import styles from './loading.module.scss'
type Props = {
	width?: string | number
	height?: string | number
}

const Loading = ({ width, height }: Props) => {
	return <Icon path="Sticker_64_Logo_Loading" className={styles.shape} style={{ width, height }}></Icon>
}

export default Loading
